import { render, staticRenderFns } from "./connections.vue?vue&type=template&id=d8c278d0&scoped=true&"
import script from "./connections.vue?vue&type=script&lang=ts&"
export * from "./connections.vue?vue&type=script&lang=ts&"
import style0 from "./connections.vue?vue&type=style&index=0&id=d8c278d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8c278d0",
  null
  
)

export default component.exports